App.controller('HomeCtrl', ['$rootScope', '$scope', '$sce', '$state', '$http', function ($rootScope, $scope, $sce, $state, $http) {
	
}]);